import { call, put } from 'redux-saga/effects';
import {
  setProgressBar,
  addProgressBar,
  removeProgressBar,
  errorPopup,
} from './Common';

const taker = (func) =>
  function* (action) {
    try {
      yield call(addProgressBar, func.name);

      yield func(action);

      yield call(removeProgressBar, func.name);
    } catch (err) {
      yield call(errorPopup, { error: err });
      yield call(removeProgressBar, func.name);
    }
  };
export default taker;
